import React from 'react'
import { ConciergeStepInfo } from '../../utils/types'
import '../../styles/WelcomeSection/ConciergeSteps.scss'

interface ConciergeStepProps {
    conciergeStepInfo: ConciergeStepInfo
}

const ConciergeStep = ({ conciergeStepInfo }: ConciergeStepProps) => {
  const { heading, bodyText } = conciergeStepInfo

  return (
        <div className="concierge_step">
            <h3>{heading}</h3>
            <p>{bodyText}</p>
        </div>
  )
}

export default ConciergeStep
